import React, { PureComponent } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { pageData } from 'decorators'

import GlobalActions from 'store/redux/global'
import { information, confirmation } from 'utils/generators/dialog'
import { basicAlert, dismisableAlert } from 'utils/generators/alert'
@pageData({ title: 'Home' })
@connect(
    null,
    { addDialog: GlobalActions.addDialog, addAlert: GlobalActions.addAlert }
)
export class Home extends PureComponent {
    render() {
        const informationDialog = information({ buttonLabel: 'close', id: 'informationHome', title: 'Information dialog', children: 'brjb' })
        const confirmationDialog = confirmation({
            onConfirmLabel: 'Console.log',
            onConfirm: () => console.log('Esto es el confirm'),
            onDismissLabel: 'close',
            id: 'confirmHome',
            title: 'Confirmation dialog',
            children: 'jkfbjkr'
        })

        const basicAlertHome = basicAlert({ type: 'info', children: 'vhvehf', id: 'basicAlertHome' })
        const alertWithTitleAndFooter = basicAlert({ type: 'info', children: 'vhvehf', id: 'basicAlertHome', title: 'bla bla', footer: 'ble ble' })
        const dismisableAlertHome = dismisableAlert({ type: 'error', title: 'dismisable alert', children: 'bjrkr', id: 'dismiss' })

        return (
            <div>
                <div className="d-flex justify-content-center">
                    <h1>HOME</h1>
                </div>

                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                    <Button color="primary" onClick={() => this.props.addDialog(informationDialog)}>
                        Information dialog
                    </Button>
                    <Button color="secondary" onClick={() => this.props.addDialog(confirmationDialog)}>
                        Confirmation dialog
                    </Button>
                </div>

                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                    <Button color="info" onClick={() => this.props.addAlert(basicAlertHome)}>
                        Basic alert
                    </Button>
                    <Button color="success" onClick={() => this.props.addAlert(alertWithTitleAndFooter)}>
                        Alert with footer and header
                    </Button>
                    <Button color="danger" onClick={() => this.props.addAlert(dismisableAlertHome)}>
                        Dismisable alert
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Home/Home.js